import React, {useState, Ref, useRef} from "react";

export const HeaderMenuItem = ({item}) => {
  const [isOpen, setIsOpen] = useState(false);

  let answerRef = useRef();
  return <div
    onMouseEnter={() => {
      setIsOpen(true);
    }}
    onMouseLeave={() => {
      setIsOpen(false);
    }}
    onFocus={(e) => {
      if (e.currentTarget === e.target) {
        setIsOpen(true);
      } else {
        setIsOpen(true);
      }
      if (!e.currentTarget.contains(e.relatedTarget)) {
        // Not triggered when swapping focus between children
        setIsOpen(true);
      }
    }}
    onBlur={(e) => {
      if (!e.currentTarget.contains(e.relatedTarget)) {
        // Not triggered when swapping focus between children
        setIsOpen(false);
      }
    }}>
    <div ref={answerRef} className={`header-wrapper__nav__content__container__item ${
      item?.IsActive ? "focus" : ""
    } ${isOpen ? 'open' : ''}`}>
      <a
        title={item?.Name}
        href={item?.Url}
      >
        <span className="menu-link">{item?.Name}</span>
      </a>
      {item?.Children?.length > 0 && <i className={'fa-solid icondrop'} aria-hidden="true"></i>}
    </div>
    {item?.Children?.length ? (
      <div
        className={`header-wrapper__nav__content__container__parent-dropdown parent-menu-dropdown ${isOpen ? 'open' : ''}`}
      >
        {item?.Children?.map((x, i) => (
          <a
            tabIndex="0"
            className="header-wrapper__nav__content__container__parent-dropdown__link"
            href={x?.Url}
            target={x.Target}
            key={`child-nav-${i}`}
          >
            <span className="underline-link">{x?.Name}</span>
          </a>
        ))}
      </div>
    ) : null}
  </div>
}